import { create } from "zustand";

/**
 * The lab's selected room (DevInjectPanel). When set, every stream this
 * browser starts — fixture injections AND the live "Talk to Brian" mic —
 * presents that room's device identity (room-scope token), as if it were the
 * ambient recorder in that room. Dev-only, and deliberately NOT persisted:
 * a stale selection silently rerouting the mic after a refresh would be a
 * foot-gun.
 */
interface LabRoomState {
  room: { id: string; name: string } | null;
  setRoom: (room: { id: string; name: string } | null) => void;
}

export const useLabRoomStore = create<LabRoomState>((set) => ({
  room: null,
  setRoom: (room) => set({ room }),
}));
